import { useState, useEffect } from 'react';
import KENYA from '../data/kenya_locations';

export default function LocationDropdown({ onChange, values = {} }) {
  const [county,    setCounty]    = useState(values.county     || '');
  const [subCounty, setSubCounty] = useState(values.sub_county || '');
  const [ward,      setWard]      = useState(values.ward       || '');

  const counties    = Object.keys(KENYA).sort();
  const subCounties = county ? Object.keys(KENYA[county]).sort() : [];
  const wards       = (county && subCounty && KENYA[county][subCounty])
    ? KENYA[county][subCounty].sort() : [];

  useEffect(() => {
    onChange({ county, sub_county: subCounty, ward });
  }, [county, subCounty, ward]); // eslint-disable-line

  function handleCounty(e) {
    setCounty(e.target.value);
    setSubCounty('');
    setWard('');
  }

  function handleSubCounty(e) {
    setSubCounty(e.target.value);
    setWard('');
  }

  const selectStyle = {
    width: '100%',
    padding: '9px 12px',
    borderRadius: '6px',
    border: '1px solid #d1d5db',
    fontSize: '14px',
    background: '#fff',
    color: '#111827',
    marginBottom: '10px',
  };

  return (
    <div>
      <label style={{ fontSize: 13, color: '#6b7280', display: 'block', marginBottom: 5 }}>
        County
      </label>
      <select value={county} onChange={handleCounty} style={selectStyle}>
        <option value="">Select county...</option>
        {counties.map(c => (
          <option key={c} value={c}>{c}</option>
        ))}
      </select>

      <label style={{ fontSize: 13, color: '#6b7280', display: 'block', marginBottom: 5 }}>
        Sub-county
      </label>
      <select
        value={subCounty}
        onChange={handleSubCounty}
        disabled={!county}
        style={{ ...selectStyle, opacity: county ? 1 : 0.5 }}
      >
        <option value="">Select sub-county...</option>
        {subCounties.map(s => (
          <option key={s} value={s}>{s}</option>
        ))}
      </select>

      <label style={{ fontSize: 13, color: '#6b7280', display: 'block', marginBottom: 5 }}>
        Ward / Village
      </label>
      <select
        value={ward}
        onChange={e => setWard(e.target.value)}
        disabled={!subCounty}
        style={{ ...selectStyle, opacity: subCounty ? 1 : 0.5 }}
      >
        <option value="">Select ward/village...</option>
        {wards.map(w => (
          <option key={w} value={w}>{w}</option>
        ))}
      </select>
    </div>
  );
}
